<template>
    <div>
        <div v-if="contents && contents.error">
            <div class="container">
                <div class="row mt-4">
                    <div class="col-lg-12">
                        <div class="alert alert-danger alert-dismissible fade show" role="alert">
                          <strong>{{ contents.type }}</strong> {{ contents.message }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="contents && contents.chart">
            <div class="container">
                <div class="row mb-4 mt-4 align-items-center">
                    <div class="col-md-2 text-center">
                        <img v-bind:src="contents.chart.image" class="img-thumbnail">
                    </div>
                    <div class="col-md-10">
                        <h2>{{ contents.chart.category.name }}</h2>
                        <h2>{{ contents.chart.title }}</h2>
                        <p>{{ contents.chart.description }}</p>
                        <a v-bind:href="contents.chart.story" target="_blank" class="btn btn-light active">Main Story</a>  <a v-bind:href="contents.chart.methodology" target="_blank" class="btn btn-light active">Methodology</a>
                    </div>
                    <div class="col-lg-12 text-center mt-4">
                        <div class="btn-group" role="group">
                          <a class="btn btn-dark text-light" v-for="content in contents.similar" v-if="content.charts[0]" v-bind:href="'/chart/' + content.charts[0].id"  v-bind:class="(content.charts[0].id == id)?'active disabled':''" >{{ content.title }}</a>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="container" v-if="id == 5">
                <div class="row mb-3">
                    <div class="col-lg-6 col-md-6">
                        <ul class="list-group">
                            <li class="list-group-item"><span class="laptop"></span> Can work remotely</li>
                            <li class="list-group-item"><span class="clock"></span> Flexible scheduling</li>
                            <li class="list-group-item"><span class="exchange"></span> Transfer to another location</li>
                        </ul>
                    </div>
                    <div class="col-lg-6 col-lg-6">
                        <ul class="list-group">
                            <li class="list-group-item"><span class="ribbon-gold"></span> Received Secretary of Defense Employer Support Freedom Award or Extraordinary Employer Support Award</li>
                            <li class="list-group-item"><span class="ribbon-silver"></span> Received Seven Seals Award, Above and Beyond Award or Pro Patria Award</li>
                            <li class="list-group-item"><span class="ribbon-bronze"></span> Received Patriot or Spouse Patriot Award</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 mb-4">
                        <input type="text" placeholder="Filter..." v-model="filterQuery" class="form-control" />
                    </div>
                </div>
            </div>
            <div class="container ">
                <div class="table-responsive">
                <table  class="table table-light table-hover ">
                    <thead class="table-dark">
                        <tr>
                            <th  scope="col" v-for="header in contents.chart.headers" class="text-center" v-if="header.show == true">{{ header.name }}</th>
                            <th  class="text-center"><span class="ion-ios-eye-outline h3"></span></th>
                        </tr>
                    </thead>
                    <tbody class="">
                        <tr v-for="(content, index) in dataToRender" class="text-center">
                            <td  v-for="header in contents.chart.headers" :style="{ 'background-color': header.column_color }" v-bind:class="cellBackground(header)"  v-if="header.show == true">
                                <span v-if="header.type == 'label'">
                                    <span class="badge-warning badge ml-1" v-for="blabel in content[header.slug].split(' ')">{{ label }}</span>
                                </span>
                                <span v-if="header.type == 'string'" v-html="formatString(header, content[header.slug])"></span>
                                <span v-if="header.type == 'progressbar'">
                                    <div class="progress">
                                        <div class="progress-bar bg-info progress-bar-striped" role="progressbar" v-bind:aria-valuenow="content[header.slug]" aria-valuemin="0" aria-valuemax="100" v-bind:style="{ width: content[header.slug] +''}">
                                        </div>{{ content[header.slug] }}
                                    </div>
                                </span>
                                <span v-if="header.type == 'number'" class="text-right" style="display:block" v-html="formatNumber(content[header.slug])"></span>
                                <span v-if="header.type == 'icon'"  v-html="formatIcons(header, content[header.slug])"></span>
                                <span v-if="header.type == 'rating'">
                                    <span v-if="content[header.slug] == 0.5">
                                        <img src="/images/rating-half.png">
                                    </span>
                                    <span v-if="content[header.slug] == 1.0">
                                        <img src="/images/rating-full.png">
                                    </span>
                                    <span v-if="content[header.slug] == 1.5" class="inline-flex">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-half.png">
                                    </span>
                                    <span v-if="content[header.slug] == 2.0" class="inline-flex">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                    </span>
                                    <span v-if="content[header.slug] == 2.5" class="inline-flex">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-half.png">
                                    </span>
                                    <span v-if="content[header.slug] == 3.0" class="inline-flex">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                    </span>
                                    <span v-if="content[header.slug] == 3.5" class="inline-flex">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-half.png">
                                    </span>
                                    <span v-if="content[header.slug] == 4.0" class="inline-flex">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                        <img src="/images/rating-full.png">
                                    </span>
                                </span>
                            </td>
                            <td><button class="btn btn-dark text-warning" data-toggle="modal" data-target="#dataModal" v-on:click="modalUp(content, contents.chart.headers)">More info</button></td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
            <div class="container" v-if="contents.chart.keys.length !== 0">
                <div class="row">
                    <div class="col-lg-12">
                      <h5>Footnotes</h5>
                      <ul class="list-unstyled">
                          <li v-for="(keyword, letter) in contents.chart.keys"><span class="text-dark">[{{ letter }}]</span> {{ keyword }}</li>
                      </ul>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="dataModal" tabindex="-1" role="dialog" aria-labelledby="dataModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="dataModalLabel">Details</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body" v-if="modelContent">
                    <table class="table table-hover table-bordered">
                        <tbody>
                            <tr v-for="current in modelContent.header">
                                <th  class="bg-dark text-light" scope="row">{{ current.name }}</th>
                                <td v-bind:class="cellBackground(current)">
                                    <span v-if="current.type == 'string'" v-html="formatString(current, modelContent.contents[current.slug])"></span>
                                    <span v-if="current.type == 'number'"  v-html="formatNumber(modelContent.contents[current.slug])" ></span>
                                    <span v-if="current.type == 'checkmark'"><h3 v-if="modelContent.contents[current.slug]" class="text-info ion-checkmark"></h3></span>
                                    <span v-if="current.type == 'icon'"  v-html="formatIcons(current, modelContent.contents[current.slug])"></span>
                                    <span v-if="current.type == 'progressbar'">
                                        <div class="progress">
                                            <div class="progress-bar bg-info progress-bar-striped" role="progressbar" v-bind:aria-valuenow="modelContent.contents[current.slug]" aria-valuemin="0" aria-valuemax="100" v-bind:style="{ width: modelContent.contents[current.slug] }">
                                            </div>{{ modelContent.contents[current.slug] }}
                                        </div>
                                    </span>
                                    <span v-if="current.type == 'footnote'">
                                        <span v-for="note in modelContent.contents[current.slug].toString().split(' ')" v-bind:key="note.id" class="badge badge-warning m-1 text-light">{{ note }}</span>
                                    </span>
                                    <span v-if="current.type == 'rating'">
                                        <span v-if="modelContent.contents[current.slug] == 0.5">
                                            <img src="/images/rating-half.png">
                                        </span>
                                        <span v-if="modelContent.contents[current.slug] == 1.0">
                                            <img src="/images/rating-full.png">
                                        </span>
                                        <span v-if="modelContent.contents[current.slug] == 1.5" class="inline-flex">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-half.png">
                                        </span>
                                        <span v-if="modelContent.contents[current.slug] == 2.0" class="inline-flex">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                        </span>
                                        <span v-if="modelContent.contents[current.slug] == 2.5" class="inline-flex">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-half.png">
                                        </span>
                                        <span v-if="modelContent.contents[current.slug] == 3.0" class="inline-flex">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                        </span>
                                        <span v-if="modelContent.contents[current.slug] == 3.5" class="inline-flex">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-half.png">
                                        </span>
                                        <span v-if="modelContent.contents[current.slug] == 4.0" class="inline-flex">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                            <img src="/images/rating-full.png">
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                id: this.$route.params.id,
                contents: null,
                filterQuery: '',
                modelContent: null
            }
        },
        mounted() {
            
        },
        created: function(){
            let self = this;
            $.get(this.computed.apiGateway + '/api/charts/' + this.id, function(response) {
                self.contents =  response;
            });
        },
        methods: {
            modalUp: function(data, header)
            {
                this.modelContent = {'contents': data, 'header': header};
            },
            formatString: function(header, content)
            {
                if(header.has_url){

                    let cnt = content.split('|')
                    let txt = cnt[0]
                    var supcnt = content.substring(content.lastIndexOf("[")+1,content.lastIndexOf("]"));
                    if(supcnt)
                    {
                       let contentsup = content.split('[')
                       txt = contentsup[0] + `<sup>` + supcnt + `</sup>`
                    }
           
                    return `<a href="`+cnt[1]+`" target="_blank" class="text-dark"><strong>`+txt+`</strong></a>`
                }

                if(content && content.indexOf("[")) {
                    var cnt = content.substring(content.lastIndexOf("[")+1,content.lastIndexOf("]"));
                    if(cnt){
                        let txt = content.split('[')
                        return txt[0] + `<sup>` + cnt + `</sup>`
                    }
                }
                 
                return content;
            },
            formatNumber(content) {
                var cnt = null
                if(content.toString().lastIndexOf("[") >= 0 && content.toString().lastIndexOf("]") >= 0){
                    cnt = content.substring(content.lastIndexOf("[")+1,content.lastIndexOf("]"));
                }

                if(cnt){
                    let txt = content.split('[')
                    return txt[0] + `<sup>` + cnt + `</sup>`
                }

                return content;
            },
            cellBackground(header) {
                return {
                    'text-left': header.direction == 'left',
                    'bg-dark text-white': header.type == 'icon'
                }
                //(header.direction == 'left')?'text-left':''
            },
            formatIcons(header, content)
            {
                if(content && content.indexOf('|')){
                    let icons = content.split('|')
                    if(icons.length > 1)
                    {
                        let icon_print = '';
                        icons.forEach(function(icon) {
                            icon_print += `<span class="`+icon+`"></span>`
                        })
                       
                        return icon_print;
                    }
                }
                if(content && content.includes('FLAG'))
                    return `<h6 class="text-danger ion-flag"></h6>`
                
                return `<h6 class="`+content+`"></h6>`
            }
        },
        computed: {
            similarTabs() {
                return this.contents.similar
            },
            dataToRender(){
                let self = this;
                return this.contents.data.filter(function(el){
                    var order_by = self.contents.default_order.filter_by
                    return el[order_by].toString().toLowerCase().indexOf(self.filterQuery.toLowerCase()) > -1;
                });
            }
            
        }
    }
</script>
